// ════════════════════════════════════════════════════════════════════════════
// TarefasPage — wrapper r140
// Escolhe entre modo "Lista" e "Agenda" via toggle.
// r171: a tela SEMPRE abre em Lista. O toggle continua funcionando dentro da
// sessão, mas a escolha não é mais restaurada no próximo acesso — abrir Tarefas
// tem que cair na lista, não no calendário.
// ════════════════════════════════════════════════════════════════════════════

import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';   // r186
import { useAuth } from '../../context/AuthContext';
import TarefasPageAgenda from './TarefasPageAgenda';
import TarefasPageLista  from './TarefasPageLista';

const STORAGE_KEY_MODO = (uid) => `tarefas:modo:${uid}`;

function TarefasPage() {
  const { usuario } = useAuth();
  const [modo, setModo] = useState('lista');  // 'lista' | 'agenda'

  // r171: limpa a preferência antiga — quem tinha 'agenda' gravado continuaria
  //       abrindo no calendário mesmo depois da mudança do default.
  useEffect(() => {
    if (!usuario?.id) return;
    try { localStorage.removeItem(STORAGE_KEY_MODO(usuario.id)); } catch {}
  }, [usuario]);

  // r186: deep link do sininho (/tarefas?tarefa_id=123) é resolvido pela visão
  //       Lista. Se o usuário estiver na Agenda, volta pra Lista antes.
  const [searchParams] = useSearchParams();
  const tarefaAlvo = searchParams.get('tarefa_id');
  useEffect(() => {
    if (tarefaAlvo) setModo('lista');
  }, [tarefaAlvo]);

  const alternarModo = (novoModo) => setModo(novoModo);

  return modo === 'agenda'
    ? <TarefasPageAgenda onAlternarModo={alternarModo} />
    : <TarefasPageLista  onAlternarModo={alternarModo} />;
}

export default TarefasPage;
